/**
 * Created by abdulhafeth on 4/17/16.
 */

(function (angular, TeamAPI, TSUtils, TeamCommunicationAPI) {
    "use strict";

    var _instance;

    var events = {
        "member_removed": [],
        "active_changed": [],
        "member_activated": [],
        "timeoffs_changed": []
    };

    var trigger = function (eventName, param1, param2, param3, param4) {
        events[eventName].forEach(function (handler) {
            handler(param1, param2, param3, param4);
        });
    };

    var TeamCommunicationService = function (hUser, teamScheduleService, tsUsersService, $state, TSSideBarService, brandServices) {

        const self = this;
        self.memberTypes = TSUtils.MEMBER_TYPES;
        self.isLoading = false;
        self.isEditing = false;
	    const _tsSideBar = new TSSideBarService();
        self.user = hUser;
        self.users = tsUsersService.users;

        teamScheduleService.getActiveBrand()
            .then(function (brand) {
                self.brand = brand;
                self.isUKBrand = brand.team_live_country_code === "UK";
                init();
            },function (){
                self.isDeactivatedUser = true;
            });

        self.sections = {
            teamWall: {selected: false},
            timeOffRequests: {selected: false},
            messages: {selected: false},
            profile: {selected: false}
        };

        var init = function () {
            if (self.user.isEmployer()) {
                self.isNewsFeedEnabled = true;
                setActive("teamWall");
            } else {
                self.isNewsFeedEnabled = self.brand.services.indexOf(brandServices.SERVICES.NEWS_FEED) > -1;
                if (self.isNewsFeedEnabled) {
                    setActive("teamWall");
                }
                else if (self.getUserType() == self.memberTypes.EMPLOYEE && !self.isUKBrand) {
                    setActive("timeOffRequests");
                }
            }
        };
        self.hideUpperMenu = false;

        /**
         * unselect all Tabs
         */
        var unselectAllTabs = function () {
            for (var index in self.sections) {
                var section = self.sections[index];
                section.selected = false;
            }
            self.isContactInfoShown = false;
            self.isRolesShown = false;
            self.isADPDetails = false;
            self.isProfileShown = false;
        };

        var setActive = function (activeTab) {
            if (!self.member || (self.member && self.member.mode !== 'GUEST') || activeTab === "profile") {

                unselectAllTabs();

                if (activeTab) {
                    self.sections[activeTab].selected = true;
                }

                setTimeout(function () {
                    trigger("active_changed", activeTab);
                }, 1);
            }
        };

        teamScheduleService.onBrandChanged(function (oldBrand, newBrand) {
            self.brand = newBrand;
            self.isUKBrand = self.brand.team_live_country_code === "UK";
            self.member = {};
            self.user_id = null;
            setTimeout(function () {
                init();
            }, 100);
        });

        self.onMemberRemoved = function (handler) {
            events["member_removed"].push(handler);
        };

        self.onActiveChanged = function (handler) {
            events["active_changed"].push(handler);
        };

        self.onMemberActivated = function (handler) {
            events["member_activated"].push(handler);
        };

        self.onTimeoffsChanged = function (handler) {
            events["timeoffs_changed"].push(handler);
        };

        self.isEmployer = function (member) {
            return member && member.types && member.types.indexOf(self.memberTypes.EMPLOYER.toUpperCase()) > -1;
        };

        self.isEmployee = function (member) {
            return member && member.types && member.types.indexOf(self.memberTypes.EMPLOYEE.toUpperCase()) > -1;
        };

        self.isActiveEmployee = function (member) {
            return member && self.isEmployee(member) && member.is_scheduling_member !== false;
        };

        /**
         * Show team wall tab
         */
        self.showTeamWall = function () {
            setActive('teamWall');
        };

        /**
         * Show time off requests tab
         * @param member
         */
        self.showTimeOffRequests = function (member) {
            if (member) {
                self.member = member;
            }

            setActive('timeOffRequests');
        };




        var parseLogHistoryAction = function(action, entry) {
            var actionmsg= "";
            switch (action.action) {
                case "SYNC":
                    actionmsg = "Synced " + ((entry.group == TeamAPI.PAYROLL_SYNC_TYPE.PERSONAL_INFO) ? "personal info" : "wages and rates") +" with ADP";
                    break;
                case "UPDATE":
                    if (action.field == "PAY_RATE_CODE") {
                        actionmsg = "Changed rate code " + action.old_value + " to " + action.new_value;
                    } else {
                        actionmsg = "Changed " + ((action.field == "NAME") ? "name" : action.field) + " from " + action.old_value + " to " + action.new_value;
                    }
                    break;
                case "ADD":
                    if (action.field == "PAY_RATE_CODE") {
                        actionmsg = "Added a new rate code " + action.new_value;
                    } else {
                        actionmsg = "Changed " + action.field + " to " + action.new_value;
                    }
                    break;
                case "DELETE":
                    if (action.field == "PAY_RATE_CODE") {
                        actionmsg = "Removed rate code "+ action.old_value;
                    } else {
                        actionmsg = "Removed " + action.field ;
                    }

                    break;

            }
            return actionmsg;
        }


        self.showAuditLog = function(brand, member) {
            var deferred = $q.defer();
                TeamAPI.getBrandUserAuditLog(brand.id, member.id).then(
                    function (logEntries) {
                        var logEnteries = _.map(logEntries, function (entry) {
                            var lastAction = "";
                            if (!tsUsersService.users[entry.actor_id]) {
                                tsUsersService.loadMemberBasicInfo(brand.id, entry.actor_id).then(function (actor) {
                                    entry.actor = actor[entry.actor_id];
                                }, function (error) {
                                    console.log(error)
                                })
                            } else {
                                entry.actor = tsUsersService.users[entry.actor_id]
                            }
                            _.map(entry.actions, function (action) {
                                if (lastAction != action.action || lastAction != "SYNC") {
                                    lastAction = action.action;
                                } else {
                                    return null;
                                }
                                action.msg = parseLogHistoryAction(action, entry);
                                return action;
                            });
                            return entry;
                        });
                        deferred.resolve(logEnteries)
                    },
                    function (error) {
                        deferred.reject(error)
                    }
                )
                return deferred.promise;

        }

        /*
         * resend activation code
         * to the employee
         */
        self.reActivate = function () {

            TeamAPI.reSendEmployeeActivationEmail(self.brand.id, self.member.id)
                .then(function (data) {
                    self.member.sent = true;
                });
        }


        /**
         * Show member profile
         * brandId, userId
         */
        self.showMemberProfile = function (brandId, userId, showRoles) {
            if (self.getUserType() == self.memberTypes.EMPLOYER) {
                // True for already handled, don't open side bar
                var routeParams = {
                    user_id: userId,
                    brand_id: brandId,
                    source: 'TL',
                };

                $state.go('appLayout.schedule.core-hr.profile', routeParams);
                return true;
            }

            self.user_id = userId;
            self.member = {id: userId};
            self.canCommunicate = false;
            tsUsersService.loadMemberDetails(brandId, userId)
                .then(function (users) {
                    self.member = users[userId] || {};

                    if (showRoles && !self.isRolesShown) {
                        self.showRoles();
                    }

                    if (self.getUserType() === self.memberTypes.EMPLOYEE) {
                        TeamCommunicationAPI.canCommunicateWithUser(brandId, userId).then(function (data) {
                            self.canCommunicate = data['can_communicate'];
                        })
                    }
                }, function (error) {
                    console.error(error);
                });

            self.member = self.users[userId] ? angular.copy(self.users[userId]) : self.member;

            setActive('profile');
            if (!showRoles) {
                self.isProfileShown = true;
                self.isContactInfoShown = false;
                self.isRolesShown = false;
                self.isADPDetails = false;
            }
        };

        /**
         * gets the current logged in user type
         */
        self.getUserType = function () {
            return hUser.getUserType();
        };

        /**
         * get current user
         */
        self.getUser = function () {
            return hUser.getUser();
        };

        /**
         * Show member contact info
         */
        self.showContactInfo = function () {
            self.isRolesShown = false;
            self.isProfileShown = false;
            self.isADPDetails = false;
            self.isContactInfoShown = true;
        };

        /**
         * Show member roles and wages
         */
        self.showRoles = function () {
            self.isContactInfoShown = false;
            self.isProfileShown = false;
            self.isADPDetails = false;
            self.isRolesShown = true;
        };

        /**
         * Show adp details
         */
        self.showADPDetails = function () {
            self.isContactInfoShown = false;
            self.isProfileShown = false;
            self.isADPDetails = true;
            self.isRolesShown = false;
        };

        /**
         * Deactivate member from brand
         */
        self.deactivateMember = function () {
            if (!self.isEmployer(self.member) && self.isActiveEmployee(self.member)) {
                var memberName = [self.member.first_name, self.member.last_name].join(" ");

                hConfirm({
                    title: $filter("translate")("Confirm Deactivation"),
                    text: $filter("translate")("Member") + " \"" + memberName + "\" " + $filter("translate")("will be deactivated, please confirm?"),
                    callback: function (confirmed) {
                        if (confirmed) {
                            tsUsersService.deactivateMember(self.brand.id, self.member.id)
                                .then(function (data) {
                                    self.member.is_scheduling_member = false;
                                    self.users[self.member.id]['is_scheduling_member'] = false;
                                    self.showMemberProfile(self.brand.id, self.member.id);
                                    teamScheduleService.triggerScheduleUpdated();
                                    trigger("member_removed", self.brand.id, self.member.id);
                                }, function (error) {
                                    console.error(error);
                                    hAlert($filter("translate")("Something went wrong"), $filter("translate")("Couldn't deactivate the user"));
                                });
                        }
                    }
                });
            }
            else {
                console.warn("Only active non employers can be deactivated");
            }
        };

        self.openConversation = function (userId) {
            $state.go('appLayout.schedule.tl-communication-hub.message',{
                id: userId
            });
            _tsSideBar.close();
        };

        /**
         * Activate member from brand
         */
        self.activateMember = function () {
            var memberName = [self.member.first_name, self.member.last_name].join(" ");

            hConfirm({
                title: $filter("translate")("Confirm activation"),
                text: $filter("translate")("Member") + " \"" + memberName + "\" " + $filter("translate")("will be activated, please confirm?"),
                callback: function (confirmed) {
                    if (confirmed) {
                        TeamAPI.sendEmployeesToSchedule(self.brand.id, [self.member.id])
                            .then(function (data) {
                                delete self.member.is_scheduling_member;
                                delete self.users[self.member.id]['is_scheduling_member'];
                                self.showMemberProfile(self.brand.id, self.member.id);
                                teamScheduleService.triggerScheduleUpdated();
                                trigger("member_activated", self.brand.id, self.member.id);
                            }, function (error) {
                                console.error(error);
                                hAlert($filter("translate")("Error"), $filter("translate")("Something went wrong"));
                            });
                    }
                }
            });

        };

	    _tsSideBar.onChange(function () {
		    if (_tsSideBar.isClosed()) {
			    self.member = {};
			    self.user_id = null;
                setTimeout(async () => {
                    try {
                        const isLoggedIn = hUser.isLoggedIn();
                        if (isLoggedIn) {
                            init();
                        }
                    } catch (err) {
                        console.error(err);
                    }
                }, 100);
            }
	    });

        self.refreshAvailabilities = function () {
            if ($state.current.name === 'appLayout.schedule.main') {
                trigger("timeoffs_changed");
            }
        };

        /**
         * This method to clear the members when needed because the whole team communication service still watch this
         * variable, for example the messages still save this user and show the messages for him
         * until one remove it
         */
        self.clearActiveMember = function () {
            self.member = {};
        };

        return self;
    };

    angular
        .module('harriApp')
        .service('TeamCommunicationService', ["hUser", "TeamScheduleService", "TSUsersService", "$state", "TSSideBarService", "brandServices", function (hUser, TeamScheduleService, TSUsersService, $state, TSSideBarService, brandServices) {
            return function () {

                if (!_instance) {
                    _instance = new TeamCommunicationService(hUser, TeamScheduleService, TSUsersService, $state, TSSideBarService, brandServices);
                }

                return _instance;
            }
        }]);

})(angular, TeamAPI, TSUtils, TeamCommunicationAPI);

